import { LocalStorage } from '../../../shared/utils';

export default function saveNamesToLS(items) {
  const filenames = Object.values(items).flat().map((item) => {
    if (item.complete) return null;
    return `${item.path}${item.name}`;
  }).filter(Boolean);
  LocalStorage.set('uploadQueue', filenames);
}
